import styled from '@emotion/styled';
import { Form } from 'formik';

export const PublicPageCardForm = styled(Form)`
    max-width: 375px;
    margin: 24px auto;
`;
